import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
import { initPixel, trackPageView } from './lib/pixel';
// Initialize Meta Pixel at module load, BEFORE React renders.
// This injects the fbevents.js script tag into the DOM as soon as
// the bundle executes, so Meta Pixel Helper detects it reliably.
initPixel();
trackPageView();
render(<App data-id="element-287" />, document.getElementById('root'));